import { zip } from "@repo/utils";
import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function resetJiraConnectionQuery(userId, companyId) {
  const { project } =  await fetchData(`api/remove-connection
`, APIMethod.DELETE, {
    baseURL: ACCESS_DOMAINS.btApi,
    params: {
      code: zip(JSON.stringify({ user_id: userId, company_id: companyId })),
    }
  });
  return project;
}